var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 779,
    height: 331,
    viewBox: "0 0 779 331",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1854_55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.299 264.064H214.83V326.314H128.833V264.064H0.674683V200.474L134.522 4.68555H214.83V199.135H250.299V264.064ZM128.833 199.135V161.651C128.833 154.623 129.168 145.252 129.502 133.203C130.172 121.155 130.506 115.13 130.841 114.461H128.498C123.479 125.84 117.791 136.215 111.433 146.256L75.9636 199.135H128.833Z",
    fill: "url(#paint0_linear_1854_55)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.278 166.002C505.278 222.898 495.574 264.733 476.835 291.173C457.762 317.613 428.65 331 389.165 331C350.684 331 321.907 317.278 302.165 289.499C282.757 261.721 273.053 220.555 273.053 166.002C273.053 108.771 282.423 66.9363 301.83 40.1618C320.903 13.3873 350.015 0 389.5 0C427.646 0 456.758 14.0566 476.166 41.8352C495.574 69.6137 505.278 110.78 505.278 166.002ZM359.384 166.002C359.384 202.482 361.727 227.583 366.077 240.971C370.761 254.693 378.123 261.386 388.831 261.386C399.539 261.386 407.235 254.358 411.919 240.301C416.269 226.245 418.612 201.478 418.612 166.002C418.612 130.191 416.269 105.425 411.919 91.0334C407.235 76.6421 399.873 69.6137 389.165 69.6137C378.458 69.6137 370.761 76.6421 366.411 90.364C361.727 104.086 359.384 129.187 359.384 166.002Z",
    fill: "url(#paint1_linear_1854_55)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M778.325 264.064H742.856V326.314H656.859V264.064H528.701V200.474L662.548 4.68555H742.856V199.135H778.325V264.064ZM657.194 199.135V161.651C657.194 154.623 657.529 145.252 657.863 133.203C658.532 121.155 658.867 115.13 659.202 114.461H656.859C651.84 125.84 646.152 136.215 639.794 146.256L603.99 199.47H657.194V199.135Z",
    fill: "url(#paint2_linear_1854_55)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1854_55",
    x1: 316.699,
    y1: 409.796,
    x2: 159.386,
    y2: -49.6561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1854_55",
    x1: 567.049,
    y1: 416.914,
    x2: 392.061,
    y2: -45.0766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1854_55",
    x1: 844.726,
    y1: 409.796,
    x2: 687.413,
    y2: -49.6561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1854_55"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 777.651,
    height: 331,
    fill: "white",
    transform: "translate(0.674683)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.4c81191951773f3f4764f1a81171d1b2.svg";
export { ForwardRef as ReactComponent };